import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { MessageOutlined, FormOutlined, RobotOutlined, StopOutlined, GlobalOutlined } from '@ant-design/icons';

const ICONS = {
  message:    <MessageOutlined />,
  input:      <FormOutlined />,
  ai_handoff: <RobotOutlined />,
  api_call:   <GlobalOutlined />,
  end:        <StopOutlined />,
};
const LABELS = {
  message:    'Message',
  input:      'Ask Input',
  ai_handoff: 'Talk to AI',
  api_call:   'API Call',
  end:        'End',
};

const truncate = (value, max = 64) => {
  const text = String(value || '').trim();
  if (!text) return '(no URL configured)';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const BotNodeView = ({ data, selected }) => {
  const type = typeof data?.node_type === 'string' && data.node_type ? data.node_type : 'message';
  const headerCls = type === 'ai_handoff' ? 'handoff' : type;
  const content = data?.content || {};
  const text = content.text || '(no text)';
  const options = Array.isArray(content.options) ? content.options : [];
  const responseKeys = Object.keys(content.response_map || {});

  return (
    <div className={`bot-node ${selected ? 'selected' : ''}`}>
      {data?.is_start && <span className="bot-node-start-flag">START</span>}
      <Handle type="target" position={Position.Top} />
      <div className={`bot-node-header ${headerCls}`}>
        {ICONS[type]} {LABELS[type] || type}
      </div>
      {type === 'api_call' ? (
        <>
          <div className="bot-node-body api-call-summary">
            <span className="api-method-pill">{String(content.method || 'GET').toUpperCase()}</span>
            <span className="api-url-text" title={content.url || ''}>{truncate(content.url)}</span>
          </div>
          {responseKeys.length > 0 && (
            <div className="bot-node-map-row">
              <span className="bot-node-map-label">Maps:</span>
              {responseKeys.slice(0, 3).map((key) => (
                <span key={key} className="bot-node-map-chip">{key}</span>
              ))}
              {responseKeys.length > 3 && <span className="bot-node-map-chip">+{responseKeys.length - 3}</span>}
            </div>
          )}
        </>
      ) : (
        <div className="bot-node-body">{text.length > 80 ? text.substring(0, 80) + '…' : text}</div>
      )}
      {type === 'message' && options.length > 0 && (
        <div className="bot-node-options">
          {options.map((opt) => (
            <div key={opt.id} className="bot-node-opt" style={{ position: 'relative' }}>
              {opt.label}
              <Handle
                type="source"
                position={Position.Right}
                id={opt.id}
                style={{ top: '50%', right: -6, background: '#4f46e5' }}
              />
            </div>
          ))}
        </div>
      )}
      {type === 'api_call' && (
        <div className="api-call-handles">
          <div className="api-call-handle-row success">
            <span>success</span>
            <Handle
              type="source"
              position={Position.Right}
              id="success"
              style={{ top: '50%', right: -6, background: '#16a34a' }}
            />
          </div>
          <div className="api-call-handle-row error">
            <span>error</span>
            <Handle
              type="source"
              position={Position.Right}
              id="error"
              style={{ top: '50%', right: -6, background: '#dc2626' }}
            />
          </div>
        </div>
      )}
      {(type === 'input' || (type === 'message' && options.length === 0)) && (
        <Handle type="source" position={Position.Bottom} id="default" />
      )}
    </div>
  );
};

export default memo(BotNodeView);
